import React, { useContext, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { MEE6GuildContext } from '../../contexts/MEE6GuildContext';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import Clyde from '../../assets/images/clyde.png';
import './MEE6Dashboard.scss';

const MEE6Dashboard = () => {
  const { guilds, isLoading, fetchGuilds } = useContext(MEE6GuildContext);

  useEffect(() => {
    fetchGuilds();
  }, [fetchGuilds]);
  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (!guilds || !Array.isArray(guilds) || guilds.length === 0) {
    return (
      <Box className="StyledContainer">
        <Sidebar />
        <Box className="StyledContent">
          <Typography variant="h2">Server List</Typography>
          <Box className="StyledButtonContainer">
            <Typography variant="body1">No guilds found.</Typography>
          </Box>
        </Box>
        <Button variant="contained" color="primary" className="StyledButton">
          Get Started
        </Button>
      </Box>
    );
  }

  return (
    <Box className="StyledContainer">
      <Sidebar />
      <Box className="StyledContent">
        <Typography variant="h2">Server List</Typography>
        <Box className="StyledButtonContainer">
          {guilds && guilds.map(guild => (
            <Box className="StyledCard" key={guild.guild_id}>
              <img 
                src={Clyde} 
                alt={guild.guild_name} 
                className="guild-icon"
              />
              <Typography variant="h5">
                {guild.guild_name && guild.guild_name.length > 30 ? guild.guild_name.substring(0, 30) + "..." : guild.guild_name}
              </Typography>
              <Link to={`/dashboard/${guild.guild_id}`}>
                <Button variant="contained" className="dashboardButton">Go To Settings</Button>
              </Link>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default MEE6Dashboard;
